var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { LevelRequirement } from "../../generic/level-requirement/LevelRequirement";
import { TextLoca } from "../../generic/text/TextLoca";
import { WorkersRequirement } from "../../generic/workers-requirement/WorkersRequirement";
var BuildingRequirements = /** @class */ (function (_super) {
    __extends(BuildingRequirements, _super);
    function BuildingRequirements() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getWorkerRequirements = function () {
            var workers = _this.props.workers;
            if (workers && workers < 0) {
                return React.createElement(WorkersRequirement, { total: workers });
            }
            else {
                return undefined;
            }
        };
        _this.getPlayerLevelRequirements = function () {
            var _a = _this.props, requiredPlayerLevel = _a.requiredPlayerLevel, playerLevel = _a.playerLevel;
            if (requiredPlayerLevel) {
                return (React.createElement("div", { className: "building-requirement__item" },
                    React.createElement(Icon, { icon: IdIcon.XpIcn, styleId: IdStyles.IconMedium }),
                    React.createElement(LevelRequirement, { available: playerLevel, required: requiredPlayerLevel })));
            }
            else {
                return undefined;
            }
        };
        _this.getAdventureLevelRequirements = function () {
            var _a = _this.props, requiredAdventurerLevel = _a.requiredAdventurerLevel, adventureLevel = _a.adventureLevel;
            if (requiredAdventurerLevel) {
                return (React.createElement("div", { className: "building-requirement__item" },
                    React.createElement(Icon, { icon: IdIcon.XpAdventureIcn, styleId: IdStyles.IconMedium }),
                    React.createElement(LevelRequirement, { available: adventureLevel, required: requiredAdventurerLevel })));
            }
            else {
                return undefined;
            }
        };
        return _this;
    }
    BuildingRequirements.prototype.render = function () {
        return (React.createElement("div", { className: "building-requirement__wrapper" },
            React.createElement("div", { className: "building-requirement__title " + IdStyles.TextButtonHeading },
                React.createElement(TextLoca, { id: IdLoca.requirement })),
            React.createElement("div", { className: "building-requirement " + IdStyles.BuildMenuRequirementWrapper },
                this.getWorkerRequirements(),
                this.getPlayerLevelRequirements(),
                this.getAdventureLevelRequirements())));
    };
    return BuildingRequirements;
}(React.PureComponent));
export { BuildingRequirements };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/BuildingRequirements.tsx
// module id = 2734
// module chunks = 3